<template>
  <article class="default-text">
    <h2>Aktuálně</h2>
    <p class="big-text">
      {{ numberWithSpaces(latestItem.value) }}
    </p>
    <div :class="['change', positiveNegative]">
      <svg
        v-if="positiveNegative === 'negative'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        fill="currentColor"
      >
        <path d="M26.86 267.8l197.1-181.1l197.1 181.1C424.2 270.6 428.1 272 432 272c4.312 0 8.609-1.719 11.75-5.156c6-6.5 5.594-16.59-.8906-22.59l-208-192c-6.156-5.688-15.56-5.688-21.72 0l-208 192c-6.484 6-6.891 16.09-.8906 22.59C10.22 273.4 20.36 273.8 26.86 267.8zM234.9 244.2c-6.156-5.688-15.56-5.688-21.72 0l-208 192c-6.484 6-6.891 16.09-.8906 22.59c5.969 6.531 16.11 6.906 22.61 .9062l197.1-181.1l197.1 181.1c3.078 2.844 6.969 4.25 10.86 4.25c4.312 0 8.609-1.719 11.75-5.156c6-6.5 5.594-16.59-.8906-22.59L234.9 244.2z" />
      </svg>
      <svg
        v-if="positiveNegative === 'positive'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        fill="currentColor"
      >
        <path d="M421.1 244.2L224 426.2l-197.1-181.1C23.78 241.4 19.89 239.1 16 239.1c-4.312 0-8.609 1.719-11.75 5.156c-6 6.5-5.594 16.59 .8906 22.59l208 192c6.156 5.688 15.56 5.688 21.72 0l208-192c6.484-6 6.891-16.09 .8906-22.59C437.8 238.6 427.6 238.2 421.1 244.2zM213.1 267.8c6.156 5.688 15.56 5.688 21.72 0l208-192c6.484-6 6.891-16.09 .8906-22.59c-5.969-6.531-16.11-6.906-22.61-.9062L224 234.2L26.86 52.26C23.78 49.41 19.89 48.01 16 48.01c-4.312 0-8.609 1.719-11.75 5.156c-6 6.5-5.594 16.59 .8906 22.59L213.1 267.8z" />
      </svg>
      <span v-if="positiveNegative === 'negative'">nárůst</span>
      <span v-if="positiveNegative === 'positive'">pokles</span>
    </div>
    <hr>
    <h2>Graf</h2>
    <!-- chart -->
    <div>
      <div id="chart-average-age" />
    </div>
    <hr>
    <h2>Tabulka</h2>
    <v-simple-table>
      <template>
        <thead>
          <tr>
            <th>Rok</th>
            <th>Počet</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in items"
            :class="getClassForItem(item.value)"
          >
            <td>{{ item.label }}</td>
            <td>{{ numberWithSpaces(item.value) }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <hr>
    <p>Aktualizováno {{ updatedAtFormatted }}</p>
    <div class="d-flex g-5 flex-wrap">
      <v-btn
        :href="printChart"
        depressed
        x-large
        class="gradient-button white--text"
      >
        Stáhnout statistiku v CSV
      </v-btn>
      <v-btn
        :href="saveChart"
        depressed
        x-large
        class="gradient-button white--text"
      >
        Uložit graf v PNG
      </v-btn>
    </div>
  </article>
</template>

<script>
import VSwitchStatsMode from './VSwitchStatsMode.vue'
import statsMixin from '../statsMixin'
import stats from '../../json/average_age.json'

export default {
  name: 'VCardAverageAgeHomepage',
  components: {
    VSwitchStatsMode
  },
  mixins: [statsMixin],
  props: {
    title: {
      type: String,
      default: () => {
        return 'Průměrný věk povinného - fyzické osoby v exekuci'
      }
    },
    subTitle: {
      type: String,
      default: () => {
        return ''
      }
    },
    detailUrl: {
      type: String,
      default: () => {
        return '/statistiky/prumerny-vek.html'
      }
    }
  },
  data () {
    return {
      statsMode: 'current',
      items: stats.data,
      meta: stats.meta
    }
  },
  methods: {
    createChart () {
      this.createColumnChart('chart-average-age')
    }
  }
}
</script>
